import ApplyForm from "../components/ApplyForm";

export default function RegistrationPage() {

    return (
        <>
            <div>
                <ApplyForm/>
            </div>
        </>
    )
}